import {useQuery, useMutation, useQueryClient} from "@tanstack/react-query";
import {useState, useEffect} from 'react';
import {
    getBasicInfo,
    addBasicInfo,
    phoneNumberUpdateSendOtp,
    phoneNumberUpdateVerifyOtp, getMerchantKYCIndiaInfo
} from "../../api/api";
import handleUnauthorized401QueryError from "../../utils/handleUnauthorized401QueryError";
import {toast} from "react-toastify";
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import Avatar from 'react-avatar';
import {Button, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row} from "reactstrap";
import CopyToClipBoard from "../../components/CopyToClipBoard";
import Loader from "../../components/Loader";

function KYCInformationTab() {
    const {refreshToken} = useContext(AuthContext);
    const queryClient = useQueryClient();
    const [profileImage, setProfileImage] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('')
    const [otp, setOtp] = useState('')
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [phoneNumbersMatch, setPhoneNumbersMatch] = useState(false);
    const [phoneNumberDetailsModal, setPhoneNumberDetailsModal] = useState(false);
    const formatGstRegistrationType = (type) => {
        if (type === "REGULAR") return "Regular (can charge GST)";
        if (type === "COMPOSITION") return "Composition Scheme (cannot charge GST)";
        return "Not GST Registered";
    };

    const {status, data, error, refetch} = useQuery({
        queryKey: ['merchant-kyc-india-info'],
        queryFn: () => getMerchantKYCIndiaInfo(),
        keepPreviousData : true,
        retry: false,
        onError: (err => {
            handleUnauthorized401QueryError(err, refreshToken, refetch)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }),
    })

    useEffect(() => {
        if (data && data.results[0] && data.results[0].profile_picture) {
            setProfileImage(data.results[0].profile_picture);
        }
    }, [data]);

    const basicInfomutation = useMutation({
        mutationFn: ({ formData, basicInfoId }) => addBasicInfo({ formData, basicInfoId }),
        onSuccess: () => {
            toast.success('Profile picture updated successfully!');
            queryClient.invalidateQueries(['basic-info']);
            queryClient.invalidateQueries(['user']);
        },
        onError: (err) => {
            toast.error(`An error occurred! ${err?.response?.data?.profile_picture}`);
        },
    });

    const sendOtpMutation = useMutation({
        mutationFn: phoneNumberUpdateSendOtp,
        onSuccess: (data, variables) => {
            setIsOtpSent(true);
            toast.success('OTP sent Successfully!');
        },
        // onError: (err) => {
        //         toast.error(err.response.data.details)
        //     }

    });

    const verifyOtpMutation  = useMutation({
        mutationFn: phoneNumberUpdateVerifyOtp,
        onSuccess: (data, variables) =>{
            setPhoneNumber(data.phone)
            toast.success('Phone Number Verified Successfully!')
            setPhoneNumberDetailsModal(false);
            refetch();
        },
        onError: (err) => {
            if (err.response?.data?.detail === 'Max limit reached for this otp verification') {
                toast.info('Please retry after 5 minutes.');
            }
        }
    })

    const handleSendOtp = () => {
        sendOtpMutation.mutate({ phone: phoneNumber });
    };

    const handleVerifyOtp = () => {
        verifyOtpMutation.mutate({ phone: phoneNumber, otp });
    };


    const phoneNumberDetailsModalToggle = () => {
        setPhoneNumberDetailsModal(!phoneNumberDetailsModal);
        setIsOtpSent(false); // Reset isOtpSent when modal toggles
        setOtp(''); // Reset otp input when modal toggles
        if (!phoneNumberDetailsModal) {
            setPhoneNumber(''); // Reset phone number input when modal is closed

        }
    };

    const handlePhoneNumberChange = (e) => {
        const newPhoneNumber = e.target.value;
        setPhoneNumber(newPhoneNumber);
        // Check if the input phone number matches the existing phone number
        const matches = newPhoneNumber === data.results[0].user.phone  || newPhoneNumber === '';
        setPhoneNumbersMatch(matches);
        if (matches) {
            toast.error('Phone number already exists.')}
    }


    const handleFileChange = (e) => {
        const profileImage = e.target.files[0];
        if (profileImage) {
            setProfileImage(profileImage);
            const formData = new FormData();
            formData.append('profile_picture', profileImage);
            basicInfomutation.mutate({
                formData: formData, basicInfoId: data.results[0].id
            });
        }
    };


    return (
        <>
            {status === 'success' | error?.response?.status === 401 && (
                <div className="row">
                    <div className="col-lg-4 col-xl-4">
                        <div className="text-center">
                            {data.results[0].profile_picture ? (
                                <img
                                    src={profileImage}
                                    alt="logo"
                                    className="rounded-circle avatar-xl img-thumbnail"
                                />
                            ) : (
                                <Avatar
                                    size={90}
                                    name={data.results[0].business_name}
                                    round
                                />
                            )}
                            {/*<h4 className="mt-3">{data.results[0].user.first_name} {data.results[0].user.last_name}</h4>*/}

                            {/*<div className="fileupload btn bx-btn-primary waves-effect waves-light mb-3">*/}
                            {/*    <span><i className="mdi mdi-pencil me-1"/> Change Profile</span>*/}
                            {/*    <Input type="file" className="upload" onChange={handleFileChange}/>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                    <div className="col-lg-8 col-xl-8">
                        <div className="table-responsive">
                            <table
                                className="table table-centered table-borderless mb-0"
                                id="basic-info">
                                <tbody>
                                <tr>
                                    <td style={{width: 200}}>User ID</td>
                                    <td>
                                        {data.results[0].user}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Gender</td>
                                    <td>{data.results[0].gender}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>ID Proof Type</td>
                                    <td>{data.results[0].identity_proof_type}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>ID Proof Number</td>
                                    <td>{data.results[0].identity_proof_number}</td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Name</td>
                                    <td>{data.results[0].business_name}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Address1</td>
                                    <td>{data.results[0].business_address1}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Address2</td>
                                    <td>{data.results[0].business_address2}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Address3</td>
                                    <td>{data.results[0].business_address3}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business State</td>
                                    <td>{data.results[0].business_state}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business City</td>
                                    <td>{data.results[0].business_city}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Pincode</td>
                                    <td>{data.results[0].business_pincode}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Proof Type</td>
                                    <td>{data.results[0].business_proof_type}</td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>Business Proof Number</td>
                                    <td>{data.results[0].business_proof_number}</td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>GSTIN</td>
                                    <td>
                                        <CopyToClipBoard link={data.results[0].gstin} />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>GST Registration Type</td>
                                    <td>{formatGstRegistrationType(data.results[0].gst_registration_type)}</td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>CIN</td>
                                    <td>{data.results[0].cin}</td>
                                </tr>
                                <tr>
                                    <td style={{width: 200}}>PAN</td>
                                    <td>{data.results[0].pan}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            )}
            <Modal className={'modal-m'} isOpen={phoneNumberDetailsModal} toggle={phoneNumberDetailsModalToggle}>
                <ModalHeader toggle={phoneNumberDetailsModalToggle} close={
                    <button className="close" onClick={phoneNumberDetailsModalToggle}>
                        &times;
                    </button>
                }>Update Phone Number</ModalHeader>
                <ModalBody>
                    <Form>

                        <Row className="form-row align-items-center">
                            <Col>
                                <Label className="visually-hidden" for="phoneNumber">Enter Phone Number</Label>
                                <Input
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    className="form-control mb-2"
                                    invalid={(sendOtpMutation.isError || verifyOtpMutation.isError) && (sendOtpMutation.error?.response?.data?.detail || sendOtpMutation.error?.response?.data?.phone || verifyOtpMutation.error?.response?.data?.phone)}
                                    onChange={handlePhoneNumberChange}
                                    value={phoneNumber}

                                />
                                <FormFeedback invalid>{(sendOtpMutation.isError && (sendOtpMutation.error?.response?.data?.detail || sendOtpMutation.error?.response?.data?.phone)) ||
                                    (verifyOtpMutation.isError && verifyOtpMutation.error?.response?.data?.phone)}</FormFeedback>
                            </Col>
                        </Row>

                        {!isOtpSent && (
                            <Button
                                type="button"
                                onClick={handleSendOtp}
                                className="btn bx-btn-primary waves-effect waves-light"
                                disabled={phoneNumbersMatch  || !phoneNumber || sendOtpMutation.isLoading}
                            
                            >
                                {sendOtpMutation.isLoading? <><Loader size={'small'}/>Sending OTP...</>: `Send OTP`}
                            </Button>
                        )}
                        {isOtpSent && (
                            <Row className="form-row align-items-center">
                                <Col>
                                    <Label className="visually-hidden" for="otp">Enter OTP</Label>
                                    <Input
                                        id="otp"
                                        name="otp"
                                        type="text"
                                        className="form-control mb-2"
                                        onChange={(e) => setOtp(e.target.value)}
                                        value={otp}
                                        invalid={verifyOtpMutation.isError && ( verifyOtpMutation.error.response.data.otp || verifyOtpMutation.error.response.data.detail)}
                                    />
                                    <FormFeedback invalid>{verifyOtpMutation.isError && ( verifyOtpMutation.error.response.data.otp || verifyOtpMutation.error.response.data.detail)}</FormFeedback>
                                </Col>
                            </Row>
                        )}
                        {isOtpSent && (
                            <Button
                                type="button"
                                onClick={handleVerifyOtp}
                                className="btn bx-btn-primary waves-effect waves-light"
                                disabled={verifyOtpMutation.isLoading}
                            >
                               {verifyOtpMutation.isLoading? <><Loader size={'small'}/>Verifying Phone Number...</>: `Verify Phone Number`} 
                            </Button>
                        )}
                    </Form>
                </ModalBody>
            </Modal>

        </>
    );
}

export default KYCInformationTab;
